import { createReducer, on } from '@ngrx/store';
import { setGlobalFilters } from '@app/store/global-filter.actions';
import { DateTime } from 'luxon';

export interface State {
  startAtOrAfter: string,
  endAtOrBefore: string,
}

export const initialState: State = {startAtOrAfter: DateTime.local().minus({month: 3}).startOf('day').toString(), endAtOrBefore: null};

export const reducer = createReducer(
  initialState,
  on(setGlobalFilters, (state, action) => ({ ...state, startAtOrAfter: action.startAtOrAfter, endAtOrBefore: action.endAtOrBefore})),
);
